import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { pb } from '../../lib/pocketbase';

export default function PartnerSuccess() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const handleSuccess = async () => {
            const accountId = searchParams.get('account_id');
            const user = pb.authStore.model;

            if (!user) {
                setError("Nicht angemeldet. Bitte melde dich an, um dein Stripe-Konto zu verknüpfen.");
                setTimeout(() => navigate('/partner-login'), 3000);
                return;
            }

            if (!accountId) {
                navigate('/partner-dashboard');
                return;
            }

            try {
                // Save the Stripe Account ID to the PocketBase User record
                await pb.collection('users').update(user.id, {
                    stripeAccountId: accountId
                });

                // Refresh the auth store so the UI sees the new stripeAccountId
                await pb.collection('users').authRefresh();

                // Redirect back to dashboard
                navigate('/partner-dashboard');
            } catch (err) {
                console.error("Error saving Stripe account ID:", err);
                setError("Fehler beim Speichern der Stripe-Verbindung.");
            }
        };

        handleSuccess();
    }, [searchParams, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 font-sans p-4">
            <div className="text-center max-w-md w-full bg-white p-8 rounded-2xl shadow-xl border border-slate-100">
                <div className="w-16 h-16 bg-gradient-to-r from-[#10B981] to-[#1E3A8A] rounded-full flex items-center justify-center mx-auto mb-6">
                    <div className="w-8 h-8 rounded-full border-4 border-tron-primary border-t-transparent animate-spin"></div>
                </div>
                <h2 className="text-2xl font-bold text-[#0F172A] mb-2" style={{ fontFamily: 'Inter Tight, sans-serif' }}>
                    Stripe wird verknüpft...
                </h2>
                <p className="text-slate-600 mb-6">
                    {error || "Bitte warten, deine Partner-Auszahlungen werden eingerichtet."}
                </p>
                {error && (
                    <button
                        onClick={() => navigate('/partner-dashboard')}
                        className="text-transparent bg-clip-text bg-gradient-to-r from-[#10B981] to-[#1E3A8A] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] font-semibold"
                    >
                        Zurück zum Dashboard
                    </button>
                )}
            </div>
        </div>
    );
}
